export default [{
    title: 'Ocorrências',
    icon: 'PackageIcon',
    route: 'audiovisual-occurrence-job-ocurrence',
    roles: ['permission.job.occurrence.view']   
  }]